export enum AvailableFields {
    thickness = 'thickness',
    width = 'width',
    length = 'length',
}
